import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { UploadFileModel } from '../upload-file.model';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';

@Component({
    selector: 'abw-upload-file-design',
    templateUrl: './upload-file-design.component.html',
    styleUrls: ['./upload-file-design.component.scss']
})
export class UploadFileDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: UploadFileModel;
    @Input() value: any;
    onComplete = new Subject();

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }

    onValueChanged(e: any) {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(file);
    }
  
    private _handleReaderLoaded(e) {
        let reader = e.target;
        const base64Datas = reader.result.substr(reader.result.lastIndexOf(',') + 1);
        //this.propagateChange(this.value);
    }
}